import React, { useContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';
import ChartKit from '../../../ChartKit/ChartKit.jsx';
import ChartTypeToggle from '../../../ChartKit/ChartTypeToggle.jsx';
import { I18nContext } from 'utils/I18n/context';

function DashboardChart(props) {
    const { t = {} } = useContext(I18nContext) || {};
    const names = t.chart || {};

    const chartData = useMemo(() => ({ labels: props.labels, metricsData: props.metricsData }), [props.labels, props.metricsData]);
    const [yAxesLeft, setYAxesLeft] = useState('Visits');
    const [yAxesRight, setYAxesRight] = useState('PublisherCreditTotalAmountConfirmed');
    const [metrics, setMetrics] = useState([]);
    const [chartType, setChartType] = useState('bar');

    const [metricsInit, setMetricsInit] = useState(false);
    const onSetMetrics = useCallback((m) => {
        if (metricsInit) return;
        setMetrics(m || []);
        setMetricsInit(true);
    }, [metricsInit]);

    return (
        <div className="card dashboard-chart-card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center flex-lg-nowrap flex-wrap w-100">
                    <div className="table-filter__item">
                        <DropdownList
                            className={'rw-dropdownlist-select dimension dimension__first'}
                            valueField={'value'}
                            textField={'title'}
                            data={metrics}
                            value={metrics.find(m => m.value === yAxesLeft)}
                            disabled={[metrics.find(m => m.value === yAxesRight)]}
                            onChange={(value) => {
                                if (value) setYAxesLeft(value.value);
                            }}
                        />
                    </div>
                    <div className="table-filter__item">
                        <DropdownList
                            className={'rw-dropdownlist-select dimension dimension__second'}
                            valueField={'value'}
                            textField={'title'}
                            data={metrics}
                            value={metrics.find(m => m.value === yAxesRight)}
                            disabled={[metrics.find(m => m.value === yAxesLeft)]}
                            onChange={(value) => {
                                if (value) setYAxesRight(value.value);
                            }}
                        />
                    </div>
                    <ChartTypeToggle 
                        value={chartType} 
                        onChange={setChartType}
                        labels={{
                            bars: names.bars || 'Bars',
                            lines: names.lines || 'Lines'
                        }}
                    />
                </div>
            </div>
            <div className="card-body">
                <div className="chart-container">
                    <ChartKit type={chartType} chartData={chartData} yAxesLeft={yAxesLeft} yAxesRight={yAxesRight} parameters={props.parameters} loading={props.loading} getMetrics={onSetMetrics} height={320} />
                </div>
            </div>
        </div>
    );
}

DashboardChart.propTypes = {
    labels: PropTypes.array,
    metricsData: PropTypes.object,
    parameters: PropTypes.object,
    loading: PropTypes.bool,
};

DashboardChart.defaultProps = { labels: [], metricsData: {}, parameters: {}, loading: false };

export default DashboardChart;